import FullParagraphDefaultProps from "segments/desktop/core-components/full-paragraph/default-props";
import { AUTO } from "constants/cloudinary-asset-qualities";
export default {
    fullParagraph: FullParagraphDefaultProps,
    backgroundImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/multiple-notes-on-the-wall.png"
    },
    assetQuality: AUTO
};
